import React from 'react'
import PropTypes from 'prop-types'
import {arc} from 'd3-shape'
import ChannelIcon from 'components/ChannelIcon'

export default class AggrSingleTouch extends React.Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    single: PropTypes.array
  }

  render() {
    const {width, height, value, single} = this.props
    const arc1 = arc()
      .innerRadius(58)
      .outerRadius(80)
      .startAngle(-Math.PI / 2)
      .endAngle(Math.PI / 2)()

    const valueAngle = value >= 50 ? (value / 100) * Math.PI / 2 : -(1 - value / 100) * Math.PI / 2
    const arc2 = arc()
      .innerRadius(58)
      .outerRadius(80)
      .startAngle(-Math.PI / 2)
      .endAngle(valueAngle)()
    return (
      <div className='agg-circle'>
        <div className='agg-circle_header'>% of Single Touch Journeys</div>
        <div className='agg-circle_content'>
          <svg width={width} height={height}>
            <g transform={`translate(${80 + (width - 160) / 2}, 80 )`}>
              <path d={arc1} style={{fill: '#f3f3f3'}} strokeWidth={8} />
              <path d={arc2} style={{fill: '#9bacbb'}} strokeWidth={8} />
              <text
                dx={-70}
                dy={12}
                style={{
                  fill: '#1f1f1f',
                  fontSize: 12,
                  textAnchor: 'middle'
                }}
              >
                0%
              </text>
              <text
                dx={70}
                dy={12}
                style={{
                  fill: '#1f1f1f',
                  fontSize: 12,
                  textAnchor: 'middle'
                }}
              >
                100%
              </text>
            </g>
            <text
              x={width}
              y={height}
              style={{
                fill: '#1f1f1f',
                fontSize: 15,
                fontWeight: 600
              }}
            >
              0%
            </text>
          </svg>
          <div className='agg-circle_animated_icon'>
            {single?.length === 1 && (
              <ChannelIcon
                className='channel-group-selector_one_channel'
                name={single[0].channel}
                group={single[0].channelGroup}
                size='12px'
                active
              />
            )}
            <div className='agg-circle_value'>{value}%</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrSingleTouch/AggrSingleTouch.js